import type { RelayId } from "./relay";

interface KibelaContextType {
  readonly guest: boolean;
  readonly team: string | undefined;

  readonly globalId: string | undefined;
  readonly userId: number | undefined;
  readonly userRelayId: RelayId | undefined;
  readonly account: string | undefined;
  readonly email: string | undefined;
  readonly role: string | undefined;
  readonly supportWidgetEnabled: boolean; // Display the widget or not.
  readonly supportChatEnabled: boolean; // If false, the support widget displays only a contact form.
  readonly appVersion: string | undefined;

  // Cache key should be mutable to purge old caches
  foldersCacheKey: string | undefined;
  customEmojisCacheKey: string | undefined;
}

const dataset = (globalThis.document &&
  globalThis.document.documentElement &&
  globalThis.document.documentElement.dataset) || {
  guest: true,
};

// kibelaContext cannot use under SSR, so shouldn't use in React Component.
export const kibelaContext: KibelaContextType = {
  globalId: dataset.globalId,
  team: dataset.team,
  userId: dataset.userId ? Number(dataset.userId) : undefined,
  userRelayId: dataset.userRelayId,
  account: dataset.account,
  email: dataset.email,
  role: dataset.role,
  guest: !!dataset.guest,
  supportWidgetEnabled: !!dataset.supportWidgetEnabled,
  supportChatEnabled: !!dataset.supportChatEnabled,
  appVersion: dataset.appVersion,
  foldersCacheKey: dataset.foldersCacheKey,
  customEmojisCacheKey: dataset.customEmojisCacheKey,
};
